"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultBarChartOptions = void 0;
var defaultBarChartOptions = {
  chart: {
    type: 'bar',
    styledMode: true
  },
  title: false,
  xAxis: {
    title: false,
    labels: {
      align: 'left',
      reserveSpace: true,
      useHTML: true,
      format: '<div class="bar-chart__label">{value}</div>'
    }
  },
  yAxis: {
    visible: false
  },
  plotOptions: {
    bar: {
      pointWidth: 20,
      colorByPoint: true
    }
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
  credits: false
};
exports.defaultBarChartOptions = defaultBarChartOptions;